import { Box, Text, chakra } from '@chakra-ui/react'
import Markdown, { RuleType } from 'markdown-to-jsx'
import type { FC } from 'react'

const ALLOWED_RULES: ReadonlySet<RuleType> = new Set([
  RuleType.breakLine,
  RuleType.orderedList,
  RuleType.paragraph,
  RuleType.text,
  RuleType.textBolded,
  RuleType.textEmphasized,
  RuleType.unorderedList,
])

export const SummaryMarkdown: FC<{ children: string }> = ({ children }) => (
  <Markdown
    options={{
      disableParsingRawHTML: true,
      overrides: {
        p: {
          component: Text,
          props: {
            marginBottom: '2',
            whiteSpace: 'break-spaces',
          },
        },
        strong: {
          component: chakra.span,
          props: {
            fontWeight: 'bold',
            whiteSpace: 'break-spaces',
          },
        },
        em: {
          component: chakra.span,
          props: {
            fontStyle: 'italic',
            whiteSpace: 'break-spaces',
          },
        },
        ul: {
          component: Box,
          props: {
            as: 'ul',
            marginLeft: '4',
            marginBottom: '2',
          },
        },
        ol: {
          component: Box,
          props: {
            as: 'ol',
            marginLeft: '4',
          },
        },
        li: {
          component: Text,
        },
      },
      renderRule: (next, node) => {
        // Allow only subset of types
        if (ALLOWED_RULES.has(node.type)) {
          return next()
        }
        return ''
      },
    }}
  >
    {children}
  </Markdown>
)
